var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoScreenHitsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1873 211.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f9ac1b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.93,162.94c1.94,16.1,11.4,31.26,38.21,31.26,21.61,0,34-11.07,34-27.1,0-15.48-10.26-22.95-31.67-31.26-28.3-10.87-37-21-37-36.35,0-19.39,14.63-37.84,46-37.84C98,61.65,109,82.29,108.72,100.8H94.78C93.41,89.44,88.41,74,61.31,74,43.1,74,31.7,83.89,31.7,98.3c0,11.35,8.36,17.15,29.76,25.46,27.2,10.6,39.46,21.53,39.46,41.07,0,25-18.11,42-51.6,42C14.91,206.82.78,187.07,0,162.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.07,164.8c-10.81,26.79-30.61,42-58.28,42-33.54,0-48.43-23.39-48.43-55,0-42.94,23.45-90.19,70.19-90.19,35.4,0,46.3,26.1,44.89,45.87H213.81c-.82-19.07-9.91-33.23-32.93-33.23-36.6,0-54.3,40.72-54.3,76.15,0,31,14.65,43.75,36.5,43.75,18.29,0,32.94-11.62,42.07-29.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.39,105.76c2.79-13.68,5.85-28.48,8.09-41.32h13.08c-.28,3.63-3,20-5.82,32.23,10.58-21.67,31.33-35,50.71-35l-3.44,15c-27.32,3-48.74,27.07-55.43,58.86L243.1,204H229.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.42,134.42c-.83,7.16-1.38,10.76-1.38,16.56,0,29.26,14.86,42.92,36.52,42.92,24.07,0,35.14-13.55,42.61-27.12H412.4c-10,22.29-26.5,40-59.1,40-33.31,0-48.19-22.91-48.19-54.23,0-40.95,22.28-90.94,71.29-90.94,35,0,46.27,24,46.27,47.33a93.36,93.36,0,0,1-3.36,25.44ZM408,121.86a64.93,64.93,0,0,0,1.11-12.69c0-23.47-11.31-34.89-34.05-34.89-24.12,0-42.91,17.16-51.48,47.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M446.5,134.42c-.83,7.16-1.38,10.76-1.38,16.56,0,29.26,14.85,42.92,36.51,42.92,24.08,0,35.14-13.55,42.62-27.12h14.22c-10,22.29-26.49,40-59.09,40-33.32,0-48.19-22.91-48.19-54.23,0-40.95,22.28-90.94,71.28-90.94,35,0,46.28,24,46.28,47.33a93.36,93.36,0,0,1-3.36,25.44ZM534,121.86a65.71,65.71,0,0,0,1.11-12.69c0-23.47-11.31-34.89-34.06-34.89-24.12,0-42.9,17.16-51.47,47.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M575.34,99.9c2.52-12.28,4.76-24,7-35.46h13.36c-.55,4.73-4.13,24.06-5.24,28,8.87-15.47,23.07-30.75,50.06-30.75,26,0,43.28,14.57,34.89,53.15L656.7,204H643.06l18.41-87.87c5.27-24.64-.27-41.27-25.19-41.27-31.23,0-48.41,30.6-54.81,60.93L566.94,204H553.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M760.14,0l-17,80.43c9-11.76,22.23-22.58,44.77-22.58,23.91,0,44.74,13,36.12,54.32L804.68,204H772l18.21-87.12c4.3-20.58.14-31.17-18.09-31.17-20.52,0-33.23,15.75-38,37.8L717,204H684.15L727.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866.24,60.64H899.1L868.75,204H835.88ZM879,0h32.87l-7.15,33.9H871.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M914.14,60.64h22.09l8.53-39.58h32.66l-8.33,39.58h28.17l-5.73,25.57H963.36l-16.09,77.08c-2.17,10.34-1.42,16.36,10.24,16.36a76.68,76.68,0,0,0,12.91-1L965.2,203c-7.84,2.54-16.27,2.62-23.64,2.62-27.38,0-32.9-15-27.76-39.68l16.7-79.7H908.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1020.24,160.09c1.17,13.24,9.68,21.74,27.74,21.74,16.29,0,23.56-7.64,23.56-18.54,0-10.53-8.17-15.72-26.91-21.94-32.68-10.48-42.7-21.9-42.7-39.2,0-24.72,19.2-44.3,56.12-44.3,39,0,55.56,20.45,54.69,42.57H1079.4c-.61-8.5-4.85-17.87-23.39-17.87-11.17,0-21,4.57-21,15.56,0,8.5,7.79,12,26.33,18.23,32.34,10.6,44.22,23.43,44.22,43.35,0,31.48-27.43,47.13-61.49,47.13-37.64,0-58.23-17.85-57.12-46.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1185.79,43.38H1129.2L1138.44.67h170.2l-9.26,42.71H1243.2L1208.7,207h-57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1341.87,207,1316.71.67h57.11l7,86.81c2.35,28.1,3.21,56.12,3.19,70.49h.92c8.19-21.35,18.24-41.66,32.65-70L1461.88.67h60.39L1408.33,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1728.31,2.1H1610.23a43.62,43.62,0,0,0-43.56,43.57V130.3a43.62,43.62,0,0,0,43.56,43.57h82.49l3.11-15L1725.2,17.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1618.54 209.54 1685.32 209.54 1689.51 189.35 1618.54 189.35 1618.54 209.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1829,2.1h-76.42l-3.15,15.18H1829a28.86,28.86,0,0,1,28.83,28.82v85.48A28.86,28.86,0,0,1,1829,160.4H1719.77l-3.14,15.18H1829a44.05,44.05,0,0,0,44-44V46.1A44.05,44.05,0,0,0,1829,2.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1709.16 211.6 1820.61 211.6 1820.61 191.21 1713.38 191.21 1709.16 211.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoScreenHitsWhite);
export default __webpack_public_path__ + "static/media/LogoScreenHitsWhite.43485f9448937ba26ca902a4f496ddd3.svg";
export { ForwardRef as ReactComponent };